module.exports = __webpack_public_path__ + "img/q5-1-5@2x.4da12c48.png";